// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"9e932f20","90":"4f852cf1","126":"bc4a6146","281":"26d83c68","407":"0edd2bc2","544":"660feedc","760":"5b7cc92f","787":"65d2dea1","788":"71cfafac","959":"60a7e91e"}[chunkId] + ".chunk.js";
};